import React, { useState, useEffect } from "react";
import Layout from "../components/Layout/Layout";
import { useParams, useNavigate } from "react-router-dom";
import { useCart } from "../context/cart";
import toast from "react-hot-toast";

import "../styles/CategoryProductStyles.css";
import axios from "axios";
import { useCallback } from "react";
const CategoryProduct = () => {
  const params = useParams();
  const navigate = useNavigate();
  const [cart, setCart] = useCart();

  const [products, setProducts] = useState([]);
  const [category, setCategory] = useState([]);

  // useEffect(() => {
  //   if (params?.slug) getPrductsByCat();
  // }, [params?.slug]);

  // const getPrductsByCat = async () => {
  //   try {
  //     const { data } = await axios.get(
  //       `/api/v1/product/product-category/${params.slug}`
  //     );
  //     setProducts(data?.products);
  //     setCategory(data?.category);
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  // useEffect(() => {
  //   if (params?.slug) getPrductsByCat();
  // }, [params?.slug, getPrductsByCat]);

  const getPrductsByCat = useCallback(async () => {
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_API}/api/v1/product/product-category/${params.slug}`,
      );

      setProducts(data?.products);
      setCategory(data?.category);
    } catch (error) {
      console.log(error);
    }
  }, [params.slug]);

  useEffect(() => {
    if (params?.slug) getPrductsByCat();
  }, [params?.slug, getPrductsByCat]);

  return (
    <Layout>
      <div className="container mt-3 category">
        <h3 className="text-center">CATEGORY - {category?.name}</h3>
        <h4 className="text-center">{products?.length} RESULTS FOUND </h4>
        <div className="row">
          <div className="col-md-12 offset-1">
            <div className="row row-cols-1 row-cols-md-3 g-3">
              {products?.map((p) => (
                <div className="card m-3" key={p._id}>
                  <img
                    src={`${process.env.REACT_APP_API}/api/v1/product/product-photo/${p._id}`}
                    className="card-img-top"
                    alt={p.name}
                  />
                  <div className="card-body">
                    <div className="card-name-price">
                      <h5 className="card-title">{p.name}</h5>
                      <h5 className="card-title card-price">
                        {p.price.toLocaleString("en-IN", {
                          style: "currency",
                          currency: "INR",
                        })}
                      </h5>
                    </div>
                    <p className="card-text ">
                      {p.description.substring(0, 60)}...
                    </p>
                    <div className="card-name-price">
                      <button
                        className="btn btn-info ms-1"
                        onClick={() => navigate(`/product/${p.slug}`)}
                      >
                        More Details
                      </button>
                      <button
                        className="btn btn-dark ms-1"
                        onClick={() => {
                          setCart([...cart, p]);
                          localStorage.setItem(
                            "cart",
                            JSON.stringify([...cart, p]),
                          );
                          toast.success("Item Added to cart");
                        }}
                      >
                        ADD TO CART
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default CategoryProduct;
